<template>
  <div class="container">
    <div v-if="loading || parsedData.length === 0" class="header">
      <p class="headerp">No edit log entries found for this kit.</p>
    </div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else class="editlog">
      <table class="styled-table">
        <thead>
          <tr>
            <th class="title-data">Changed By</th>
            <th class="title-data">Old Value</th>
            <th class="title-data">New Value</th>
            <th class="title-data">Date</th>
           
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in parsedData" :key="item.id">
            <td class="changed-name">{{ item.user.first_name}} {{ item.user.last_name}}</td>
            <td>
              <ul>
                <li v-for="desc in item.description" :key="desc.key">
                  <span v-if="desc.oldValue != desc.newValue && desc.key != 'confirmed_phone' && desc.key != 'confirmed_email'">
                 
                    <span class="key-label">  <span v-if="desc.entity == 'Indoor'" >Indoor sample</span> {{ formatText(desc.key,desc.entity) }}:</span>
                    <span class="value-label">{{ formatValue(desc.oldValue) }}</span>
                  </span> 
                </li>
              </ul>
            </td>
            <td>
              <ul>
                <li v-for="desc in item.description" :key="desc.key">
                  <span v-if="desc.oldValue != desc.newValue && desc.key != 'confirmed_phone' && desc.key != 'confirmed_email'">
                    <span class="key-label">  <span v-if="desc.entity == 'Indoor'" >Indoor sample</span> {{ formatText(desc.key,desc.entity) }}:</span>
                    <span class="value-label">{{ formatValue(desc.newValue) }}</span>
                  </span> 
                </li>
              </ul>
            </td>
            <td>{{ formatDate(item.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
export default {
  data() {
    return {
      logs: [],
      loading: true,
      error: null
    };
  },
  computed: {
    ...mapGetters(['getkitLogData']),
    parsedData() {
      if(this.logs.length > 0){
        return this.logs.map((item) => {
          try {
            const description = JSON.parse(item.description.replace(/\\/g, ''));
            return { ...item, description };
          } catch (e) {
            return { ...item, description: [] };
          }
        });
      } else {
        return [];
      }
    },
  },
  watch: {
    getkitLogData(obj){
      this.logs  = obj;
    }
  },
  methods: {
    isValidDate(dateString) {
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    formatDate(dateString) {
      return moment(dateString).format('MM-DD-YYYY hh:mm A');
    },
    formatValue(value) {
      if(value == 0) {
        return 'false';
      } else if(value == 1){
        return 'true';
      }
      return this.isValidDate(value) ? this.formatDate(value) : value;
    },
    formatText(str, ent) {
      if (!str) return '';
      if(ent == 'Indoor') {
        return Number(str)+1;
      }
      return str
        .split('_')                      // Split by underscore
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize each word
        .join(' ');                      // Join with a space
    }
  },
  mounted(){
    this.logs = this.$store.getters.getkitLogData;
    this.loading = false;
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}


th, td {
  padding: 8px;
}

th {
  background-color: #005eb8;
  color: #f5f7fa;
  text-align: left;
  font-family: TTNormsLight, sans-serif;
}
.headerp {
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
}
.header{
  margin-bottom: 2%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;
}
.container {
  padding-top: 30%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 200px; /* Adjust as needed for your layout */
}
.editlog{
  height: 500px;
}
.key-label {
  min-width: 150px; /* Set a minimum width for key to align values */
  font-weight: bold; /* Make the key label bold */
}

.value-label {
  margin-left: 8px; /* Add space before the value */
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.styled-table tbody tr .changed-name{
  width:150px !important;
}
.entity-label {
  font-weight: bold; /* Highlight the entity label */
  margin-right: 8px; /* Add space after "Indoor sample" */
  width: 20px;
}
</style>
